<template>
    <nav
        id="the-breadcrumbs"
        class="breadcrumb"
        :class="{'is-hidden-mobile': !breadcrumbs.length}"
        aria-label="breadcrumbs"
    >
        <ul>
            <template v-if="breadcrumbs.length">
                <li v-for="(breadcrumb, i) in breadcrumbs"
                    :key="`breadcrumb-${i}`"
                    :class="{ 'is-active': !breadcrumb.route || breadcrumb.route.name === route.name }"
                >
                    <router-link v-if="breadcrumb.route" :to="breadcrumb.route">
                        {{breadcrumb.title}}
                    </router-link>
                    <span v-else class="breadcrumb-current" aria-current="page">{{breadcrumb.title}}</span>
                </li>
            </template>
            <li v-else aria-hidden="true">&nbsp;</li>
        </ul>
    </nav>
</template>

<script setup lang="ts">

  import _ from 'lodash';
  import { computed } from "vue";
  import { useRoute } from "vue-router";
  import { storeToRefs } from 'pinia';
  import {
    findRouteByName,
  } from "@/internal";
  import {useProjectStore} from "@/stores/ProjectStore";

  const route = useRoute();
  const {project, viewBidPackageId} = storeToRefs((useProjectStore()));

  const breadcrumbs = computed(() => {
    const breadcrumbs = (route.meta && route.meta.breadcrumbs) ? route.meta.breadcrumbs : [];

    const resolvedBreadcrumbs = breadcrumbs.map((breadcrumb) =>  {
      let title = '';
      let foundRoute = findRouteByName(breadcrumb);

      if (foundRoute && foundRoute.meta) {

        foundRoute.params = Object.fromEntries(
          Object.entries(route.params).filter(([name]) => foundRoute.path.includes(`:${name}`)),
        );

        if (foundRoute.meta.useModelForTitle) {
          const modelName = _.camelCase(foundRoute.meta.useModelForTitle);
          let model = null;

          if (modelName === 'project') {
            model = <Record<string, any>>project.value;
          }

          if (model) {
            const modelTitles = <Record<string, string>>{
              project: 'name',
              formQuestion: 'question',
              formResponse: 'title',
            };

            title = model ? model[modelTitles[modelName]] : '';

            if (modelName === 'project' && model.bid_phase_name?.trim()) {
              title = `${title} (${model.bid_phase_name.trim()})`;
            }
          } else {
            title = '';
          }
        }
        else if (foundRoute.meta.title) {
          title = foundRoute.meta.title;
        }
      }
      else {
        return false;
      }

      return {
        title,
        route: foundRoute,
      };
    }).filter((breadcrumb): breadcrumb is { title: string; route: any } => {
      return breadcrumb !== false && Boolean(breadcrumb.title);
    });

    const bidPackage = project.value?.bid_packages?.find((bidPackage: any) => bidPackage.id === viewBidPackageId.value);

    if (bidPackage?.name) {
      resolvedBreadcrumbs.push({
        title: bidPackage.name,
        route: null,
      });
    }

    return resolvedBreadcrumbs;
  });

</script>

<style scoped lang="scss">
    #the-breadcrumbs {
      .breadcrumb-current {
        align-items: center;
        color: $text;
        display: flex;
        font-weight: 500;
        justify-content: center;
        padding: 0 .75em;
      }
    }
</style>
